import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    SpsCheckboxDropdownComponent,
    SpsDropdownComponent,
    SpsDropdownOptionComponent,
    SpsSplitButtonComponent,
} from "../components/index";
import { SpsDSCoreModule } from "./sps-ds-core.module";
import { SpsOptionListModule } from "./sps-option-list.module";

@NgModule({
    imports: [
        CommonModule,
        SpsOptionListModule,
        SpsDSCoreModule,
    ],
    declarations: [
        SpsDropdownComponent,
        SpsDropdownOptionComponent,
        SpsCheckboxDropdownComponent,
        SpsSplitButtonComponent,
    ],
    exports: [
        SpsDropdownComponent,
        SpsDropdownOptionComponent,
        SpsCheckboxDropdownComponent,
        SpsSplitButtonComponent,
    ],
})
export class SpsDropdownModule {}
